module.exports = __webpack_public_path__ + "front/img/p5.46fc8339.png";